
import { WizardStep } from "@/components/ui/wizard/Wizard";

export const businessOnboardingSteps: WizardStep[] = [
  {
    id: "business-info",
    title: "Business Info",
    description: "Tell us about your business"
  },
  {
    id: "online-presence",
    title: "Online Presence",
    description: "Connect your website and brand assets"
  },
  {
    id: "brand-voice",
    title: "Brand Voice",
    description: "Define your communication style"
  },
  {
    id: "review",
    title: "Review",
    description: "Confirm your information"
  }
];
